<template>
  <div class="product-detail-wrap" ref="productList">
    <Header />
    <div class="content-wrap">
      <BigTitle :text="info.name" :bg-text="info.name" :english="info.english" :is-bg="true"/>
      <div class="tag-box" v-if="info.advantage">
        <span>产品优势和特点：{{ info.advantage }}</span>
      </div>
      <div class="detail-box">
        <div class="title">产品简介</div>
        <div class="desc-box">
          <img v-if="info.image" :src="info.image" alt="">
          <img v-if="info.image1" :src="info.image1" alt="">
          <div class="letter">
            <div class="desc" v-for="(item, index) in info.desc" :key="index">
              {{ item }}
            </div>
            <div class="desc" v-for="item in info.engDesc" :key="item">
              {{ item }}
            </div>
          </div>
        </div>
        <div class="title" v-if="info.id === '12' || info.id === '31'" style="margin-top: 16px">设备特点与优势( Equipment characteristics and advantages )</div>
        <div class="advantage-box" v-if="info.id === '12' || info.id === '31'">
          <div class="advantage-item" v-for="(item, index) in info.advantageList" :key="index">
            <div class="red"><i class="el-icon-star-on red"></i>{{ item.title }}</div>
            <div class="black">{{ item.chinese }}</div>
            <div class="gray">{{ item.english }}</div>
          </div>
        </div>
        <div class="title" v-if="info.imageList && info.imageList.length > 0" style="margin-top: 0.32rem">主要技术参数</div>
        <div class="column-center" v-if="info.imageList && info.imageList.length > 0">
          <span v-for="(item, index) in info.imageList" :key="index">
            <img :src="item" alt="" @click="showImagePreview(item)">
          </span>
        </div>
      </div>
    </div>
    <Bottom />
  </div>
</template>

<script>
import Header from '@/views/mobile/components/Header'
import Bottom from '@/views/mobile/components/Bottom'
import {eduProducts, indProducts, lanProducts} from '@/assets/products'
import BigTitle from './components/BgTitle'
export default {
  name: "ProductDetail",
  components: { Bottom, Header, BigTitle },
  data(){
    return{
      eduProducts,
      lanProducts,
      indProducts,
      id:0,
      name: '',
      image: '',
      english: '',
      info: {}
    }
  },
  created (){
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    init() {
      document.documentElement.scrollTop = 0
      this.id = this.$route.query.id
      this.handleDetail()
    },
    handleDetail () {
      let crusherIds = ['1', '2', '11', '12', '21', '22', '31', '32', '41']
      let screenIds = ['3', '4']
      if(crusherIds.includes(this.id)) {
        eduProducts.map(item => {
          if(item.id === this.id) {
            this.info = item
          }
        })
      } else if (screenIds.includes(this.id)) {
        lanProducts.map(item => {
          if(item.id === this.id) {
            this.info = item
          }
        })
      } else {
        indProducts.map(item => {
          if(item.id === this.id) {
            this.info = item
          }
        })
      }
    },
    showImagePreview(item) {
      const image = new Image();
      image.src = item;
      image.onload = () => {
        // 创建弹出层
        const previewContainer = document.createElement('div');
        previewContainer.style.position = 'fixed';
        previewContainer.style.top = 0;
        previewContainer.style.bottom = 0;
        previewContainer.style.left = 0;
        previewContainer.style.right = 0;
        previewContainer.style.backgroundColor = 'rgba(0,0,0,0.8)';
        previewContainer.style.display = 'flex';
        previewContainer.style.justifyContent = 'center';
        previewContainer.style.alignItems = 'center';
        document.body.appendChild(previewContainer);
        // 在弹出层中添加图片
        const previewImage = document.createElement('img');
        previewImage.src = item;
        previewImage.style.maxWidth = '100%';
        previewImage.style.maxHeight = '100%';
        previewContainer.appendChild(previewImage);
        // 点击弹出层，关闭预览
        previewContainer.addEventListener('click', () => {
          document.body.removeChild(previewContainer);
        });
      };
    }
  }
}
</script>

<style lang="less" scoped>
.product-detail-wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  .content-wrap {
    width: 100%;
    .tag-box {
      color: #f56c6c;
      border: 1px dashed #f56c6c;
      font-size: 0.4rem;
      padding: 0.32rem;
      margin: 0.32rem;
    }
    .detail-box {
      width: calc(100% - 0.64rem);
      margin: 0.32rem;
      .title {
        padding: 0 0 0 0.16rem;
        border-left: 0.1rem solid #3a8ee6;
        font-size: 0.4rem;
        color: #3a8ee6;
        margin-bottom: 0.16rem;
      }
      .desc-box {
        width: 100%;
        display: flex;
        flex-direction: column;
        img {
          margin-top: 0.16rem;
          width: 100%;
          height: 100%;
        }
        .letter {
          margin-top: 0.16rem;
          display: flex;
          flex-direction: column;
          flex: 1;
          font-size: 0.4rem;
        }
        .desc {
          margin-top: 0.16rem;
          display:flex;
          white-space: pre-wrap;
          text-indent: 2em;
        }
      }
    }
    .column-center {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        width: 100%;
        height: 5rem;
      }
    }
    .advantage-box {
      .advantage-item {
        font-size: 0.4rem;
        .red {
          margin-top: 0.16rem;
          color: #F15454;
        }
        .black {
          margin-top: 0.16rem;
          color: #444444;
        }
        .gray {
          margin-top: 0.16rem;
          color: rgba(39, 46, 58, 0.8);
        }
      }
    }
  }
}
</style>
